/* SK Cart Drawer Filled - Cantidad, eliminar, cupon, cross-sell */
(function () {
  'use strict';

  /* Obtener el section ID del cart-items-component del drawer */
  function getDrawerSectionId() {
    var el = document.querySelector('cart-items-component[data-drawer][data-section-id]');
    return el ? el.dataset.sectionId : null;
  }

  /* Scroll a la zona superior del drawer (lista de productos), como reaccion
     visible al anadir algo desde el cross-sell de abajo.
     El dialog tiene scroll-lock y bloquea scrollTo({behavior:'smooth'}), pero asignar
     scrollTop directamente si funciona -> animacion suave manual con rAF. */
  function scrollDrawerToTop() {
    var inner = document.querySelector('.cart-drawer__inner');
    if (!inner) return;
    var start = inner.scrollTop;
    if (start <= 0) return;
    var duration = 350;
    var startTime = null;
    function step(ts) {
      if (startTime === null) startTime = ts;
      var p = Math.min((ts - startTime) / duration, 1);
      var ease = 1 - Math.pow(1 - p, 3); /* easeOutCubic */
      inner.scrollTop = start * (1 - ease);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* Barra de tramos: el HTML nuevo llega ya en su estado final; se parte del ancho
     anterior y se deja que la transicion CSS lleve el relleno y los hitos al nuevo. */
  function animateTiers(root, oldWidth) {
    var fill = root.querySelector('.sk-cdrf__progress-fill');
    if (!fill || oldWidth === null) return;
    var target = fill.style.width;
    var marks = root.querySelectorAll('.sk-cdrf__milestone--done, .sk-cdrf__milestone--active');
    var states = [];
    for (var i = 0; i < marks.length; i++) {
      var cls = marks[i].classList.contains('sk-cdrf__milestone--done') ? 'sk-cdrf__milestone--done' : 'sk-cdrf__milestone--active';
      states.push([marks[i], cls]);
      marks[i].classList.remove(cls);
    }
    fill.style.transition = 'none';
    fill.style.width = oldWidth;
    /* Forzar reflow para que el navegador registre el estado inicial */
    fill.offsetWidth;
    fill.style.transition = '';
    requestAnimationFrame(function () {
      fill.style.width = target;
      for (var j = 0; j < states.length; j++) states[j][0].classList.add(states[j][1]);
    });
  }

  /* Refrescar el contenido del drawer via Section Rendering API */
  function refreshDrawer(sectionId) {
    if (!sectionId) sectionId = getDrawerSectionId();
    if (!sectionId) return Promise.resolve();

    return fetch('/?sections=' + sectionId)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;

        var temp = document.createElement('div');
        temp.innerHTML = html;
        var freshItems = temp.querySelector('cart-items-component');
        var currentItems = document.querySelector('cart-items-component[data-section-id="' + sectionId + '"]');
        if (freshItems && currentItems) {
          /* Guardar el ancho de la barra de tramos para animarla tras el repintado */
          var oldFill = currentItems.querySelector('.sk-cdrf__progress-fill');
          var oldWidth = oldFill ? (oldFill.style.width || '0%') : null;
          currentItems.innerHTML = freshItems.innerHTML;
          animateTiers(currentItems, oldWidth);
          /* Re-init si aparecio .sk-cdrf */
          var cdrf = currentItems.querySelector('.sk-cdrf');
          if (cdrf && !cdrf.dataset.skInit) {
            initDrawerFilled(cdrf);
          }
        }
      })
      .catch(function () {
        window.location.reload();
      });
  }

  /* Cross-sell: mostrar 2 productos al azar del pool renderizado (si hay mas de 2) */
  function randomizeCrossSell(container) {
    var grid = container.querySelector('.sk-cdrf__cross-sell-cards');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.sk-cdrf__cs-card'));
    if (cards.length <= 2) return;
    var pick = [];
    while (pick.length < 2) {
      var r = Math.floor(Math.random() * cards.length);
      if (pick.indexOf(r) === -1) pick.push(r);
    }
    for (var c = 0; c < cards.length; c++) {
      if (pick.indexOf(c) === -1) { cards[c].setAttribute('hidden', ''); }
      else { cards[c].removeAttribute('hidden'); }
    }
  }

  function initDrawerFilled(container) {
    if (container.dataset.skInit) return;
    container.dataset.skInit = 'true';

    randomizeCrossSell(container);

    var sectionId = container.dataset.sectionId;

    /* --- Cupones: la verdad esta en /cart.js, no en el DOM ---------------------
       Liquid pinta las pildoras desde cart.discount_applications, que NO incluye los
       cupones de portes gratis: esa lista solo trae los descuentos que asignan importe
       a algo del carrito, y el carrito no tiene linea de envio. Resultado: un codigo de
       portes quedaba invisible y, como los codigos se leian de las pildoras, se perdia
       al aplicar un segundo cupon. Los sincronizamos desde /cart.js, que si los trae. */
    var codigosAplicados = null;   /* null = aun sin consultar */

    function leerPildoras() {
      var out = [];
      var pills = container.querySelectorAll('.sk-cdrf__coupon-pill');
      for (var i = 0; i < pills.length; i++) {
        if (pills[i].dataset.discountCode) out.push(pills[i].dataset.discountCode);
      }
      return out;
    }

    function crearPildora(code) {
      var pill = document.createElement('span');
      pill.className = 'sk-cdrf__coupon-pill';
      pill.dataset.discountCode = code;
      pill.appendChild(document.createTextNode(code + ' '));
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sk-cdrf__coupon-pill-remove';
      btn.setAttribute('data-action', 'remove-discount');
      btn.setAttribute('aria-label', 'Eliminar cupón ' + code);
      btn.textContent = '×';
      pill.appendChild(btn);
      return pill;
    }

    /* Pintar las pildoras de los codigos que Liquid no ha pintado */
    function pintarPildorasQueFaltan(codes) {
      if (!codes.length) return;
      var puestos = leerPildoras();
      for (var p = 0; p < puestos.length; p++) puestos[p] = puestos[p].toLowerCase();
      var zona = container.querySelector('.sk-cdrf__coupon-pills');
      for (var i = 0; i < codes.length; i++) {
        if (puestos.indexOf(codes[i].toLowerCase()) !== -1) continue;
        if (!zona) {
          var cupon = container.querySelector('.sk-cdrf__coupon');
          if (!cupon || !cupon.parentNode) return;
          zona = document.createElement('div');
          zona.className = 'sk-cdrf__coupon-pills';
          cupon.parentNode.insertBefore(zona, cupon.nextSibling);
        }
        zona.appendChild(crearPildora(codes[i]));
      }
    }

    function sincronizarCupones() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var codes = [], dc = cart.discount_codes || [];
          for (var i = 0; i < dc.length; i++) { if (dc[i].applicable) codes.push(dc[i].code); }
          codigosAplicados = codes;
          pintarPildorasQueFaltan(codes);
          return codes;
        })
        .catch(function () { return codigosAplicados || leerPildoras(); });
    }

    sincronizarCupones();

    /* Actualizar linea del carrito */
    function changeCart(line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              showItemError(line, err.description || err.message || 'Error al actualizar');
              refreshDrawer(sectionId);
              return null;
            });
          }
          return res.json();
        })
        .then(function (cart) {
          if (!cart) return;
          /* Avisar al estimador de envio con el carrito ya actualizado */
          if (window.skShippingCoupon) window.skShippingCoupon.set(cart);
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            /* itemCount: cart-icon.js lo lee de detail.data o esconde el badge.
               skDrawerHandled: este refresco lo hacemos nosotros, que el listener global no repita. */
            detail: { cart: cart, skDrawerHandled: true, data: { itemCount: cart.item_count } }
          }));
          refreshDrawer(sectionId);
        })
        .catch(function () {
          window.location.reload();
        });
    }

    /* Mostrar error en una linea del carrito */
    function showItemError(line, msg) {
      var el = container.querySelector('[data-error-line="' + line + '"]');
      if (el) el.textContent = msg;
    }

    /* Gestionar cupones */
    function updateDiscountCodes(codes, onError) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: codes.join(',') })
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.discount_codes && onError) {
            for (var i = 0; i < data.discount_codes.length; i++) {
              if (!data.discount_codes[i].applicable) {
                onError('Código "' + data.discount_codes[i].code + '" no válido o no aplicable');
              }
            }
          }
          /* Avisar al estimador de envio con el carrito ya actualizado */
          if (window.skShippingCoupon) window.skShippingCoupon.set(data);
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { cart: data, skDrawerHandled: true, data: { itemCount: data.item_count } }
          }));
          refreshDrawer(sectionId);
        })
        .catch(function () {
          if (onError) onError('Error al procesar el cupón');
        });
    }

    /* Aplicar cupon */
    function applyDiscount(code) {
      var errorEl = container.querySelector('.sk-cdrf__coupon-error');
      if (errorEl) errorEl.textContent = '';
      /* Hay que mandar TODOS los codigos: uno de portes no tiene pildora y si no va en la
         lista, /cart/update.js lo borra. Usamos la lista ya sincronizada; solo si no la
         tenemos gastamos una vuelta a /cart.js (si no, el click tarda ~100ms de mas). */
      var anadir = function (codes) {
        for (var i = 0; i < codes.length; i++) {
          if (codes[i].toLowerCase() === code.toLowerCase()) return;
        }
        var nuevos = codes.slice();
        nuevos.push(code);
        updateDiscountCodes(nuevos, function (msg) {
          var el = container.querySelector('.sk-cdrf__coupon-error');
          if (el) el.textContent = msg;
        });
      };
      if (codigosAplicados) anadir(codigosAplicados.slice());
      else sincronizarCupones().then(anadir);
    }

    /* Eliminar un cupon especifico */
    function removeDiscount(codeToRemove) {
      var quitar = function (codes) {
        var filtered = [];
        for (var i = 0; i < codes.length; i++) {
          if (codes[i].toLowerCase() !== codeToRemove.toLowerCase()) filtered.push(codes[i]);
        }
        updateDiscountCodes(filtered);
      };
      if (codigosAplicados) quitar(codigosAplicados.slice());
      else sincronizarCupones().then(quitar);
    }

    /* Codigos actuales: /cart.js manda; las pildoras solo son el plan B */
    function getExistingCodes() {
      if (codigosAplicados) return codigosAplicados.slice();
      return leerPildoras();
    }

    /* Delegacion de eventos */
    container.addEventListener('click', function (e) {
      var btn, item, line;

      /* +/- cantidad */
      btn = e.target.closest('[data-action="increase"], [data-action="decrease"]');
      if (btn) {
        item = btn.closest('.sk-cdrf__item');
        if (!item) return;
        line = parseInt(item.dataset.line, 10);
        var qtyEl = item.querySelector('.sk-cdrf__qty-value');
        var currentQty = parseInt(qtyEl.textContent, 10) || 1;
        var newQty = btn.dataset.action === 'increase' ? currentQty + 1 : currentQty - 1;
        if (newQty < 1) newQty = 0;
        if (newQty > 0) qtyEl.textContent = newQty;
        changeCart(line, newQty);
        return;
      }

      /* Eliminar producto */
      btn = e.target.closest('[data-action="remove"]');
      if (btn) {
        item = btn.closest('.sk-cdrf__item');
        if (!item) return;
        line = parseInt(item.dataset.line, 10);
        item.style.opacity = '0.5';
        item.style.pointerEvents = 'none';
        changeCart(line, 0);
        return;
      }

      /* Borrar todo */
      if (e.target.closest('.sk-cdrf__clear-all')) {
        if (!confirm('¿Vaciar el carrito?')) return;
        fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' }
        })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { cart: { item_count: 0 }, skDrawerHandled: true, data: { itemCount: 0 } } }));
            refreshDrawer(sectionId);
          })
          .catch(function () { window.location.reload(); });
        return;
      }

      /* Aplicar cupon */
      if (e.target.closest('.sk-cdrf__coupon-btn')) {
        var input = container.querySelector('.sk-cdrf__coupon-input');
        var code = input ? input.value.trim() : '';
        if (code) applyDiscount(code);
        return;
      }

      /* Eliminar cupon */
      var removeBtn = e.target.closest('[data-action="remove-discount"]');
      if (removeBtn) {
        var pill = removeBtn.closest('.sk-cdrf__coupon-pill');
        var discountCode = pill ? pill.dataset.discountCode : '';
        if (discountCode) {
          /* Feedback inmediato, pero en el siguiente tick. Si sacamos la pildora del DOM
             durante el propio click, el "cerrar al clicar fuera" del dialog (isClickedOutside
             hace dialog.contains(event.target)) ve un target ya desconectado, lo toma por un
             click en el fondo y CIERRA el carrito lateral. */
          setTimeout(function () {
            if (pill && pill.parentNode) pill.parentNode.removeChild(pill);
          }, 0);
          removeDiscount(discountCode);
        }
        return;
      }

      /* Cross-sell: anadir al carrito */
      var addBtn = e.target.closest('[data-action="add-cross-sell"]');
      if (addBtn) {
        e.preventDefault();
        var variantId = addBtn.dataset.variantId;
        if (!variantId) return;
        addBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            return fetch('/cart.js');
          })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            if (window.skShippingCoupon) window.skShippingCoupon.set(cart);
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { cart: cart, skDrawerHandled: true, data: { itemCount: cart.item_count } }
            }));
            /* Tras re-renderizar la lista de arriba, subir el drawer para que
               el usuario vea que el producto se ha anadido (reaccion). */
            refreshDrawer(sectionId).then(scrollDrawerToTop);
          })
          .catch(function () {
            addBtn.disabled = false;
          });
        return;
      }
    });

    /* Enter en input cupon */
    container.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('.sk-cdrf__coupon-input')) {
        e.preventDefault();
        var code = e.target.value.trim();
        if (code) applyDiscount(code);
      }
    });
  }

  /* Inicializar todas las instancias */
  var sections = document.querySelectorAll('.sk-cdrf');
  for (var i = 0; i < sections.length; i++) {
    initDrawerFilled(sections[i]);
  }

  /* Reiniciar en el Customizer */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.sk-cdrf');
    if (section) initDrawerFilled(section);
  });

  /*
   * Listener GLOBAL: cuando el tema despacha cart:update (add-to-cart, etc.),
   * refrescamos el drawer completo via Section Rendering API.
   * Esto funciona incluso si el carrito estaba vacio (no habia .sk-cdrf).
   */
  var refreshTimer = null;
  document.addEventListener('cart:update', function (e) {
    /* Si el evento sale del propio drawer, el refresco ya lo ha lanzado quien lo disparo:
       repetirlo aqui hacia que el drawer se repintase dos veces por cada accion. */
    if (e && e.detail && e.detail.skDrawerHandled) return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      refreshDrawer();
    }, 200);
  });

  /* MutationObserver: re-init cuando el morph reemplaza .sk-cdrf */
  var cartComponent = document.querySelector('cart-items-component[data-drawer]');
  if (cartComponent) {
    new MutationObserver(function () {
      var fresh = cartComponent.querySelector('.sk-cdrf');
      if (fresh && !fresh.dataset.skInit) {
        initDrawerFilled(fresh);
      }
    }).observe(cartComponent, { childList: true, subtree: true });
  }
})();
